import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4.5 9h5m-2.5 0v6","key":"svg-0"}],["path",{"d":"M13 15v-6l3 4l3 -4v6","key":"svg-1"}]]

/**
 * IconTrademark
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItdHJhZGVtYXJrIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik00LjUgOWg1bS0yLjUgMHY2IiAvPgogIDxwYXRoIGQ9Ik0xMyAxNXYtNmwzIDRsMyAtNHY2IiAvPgo8L3N2Zz4=) - https://tabler.io/icons/icon/trademark
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconTrademark = createReactComponent('outline', 'trademark', 'Trademark', __iconNode);

export default IconTrademark;